import React from 'react';

import { IWidget, ParsedEntry } from '@/contentful/types';

import ServicePartyInfo from '@components/common/ServicePartyInfo';
import { useApartmentProperties } from '@hooks/useApartmentProperties';
import { isLocalOrTestEnv } from '@utils/featureFlags';

export const ServiceParty = ({
  data: { parameters },
}: {
  data: ParsedEntry<IWidget>;
}) => {
  const properties = useApartmentProperties();

  if (!isValidParameters(parameters)) {
    return isLocalOrTestEnv ? (
      <div>Invalid or missing serviceParty key</div>
    ) : null;
  }

  const serviceParty = properties[parameters.serviceParty];

  if (serviceParty) {
    return <ServicePartyInfo serviceParty={serviceParty} className="my-5" />;
  }

  return null;
};

const servicePartyKeys = [
  'maintenanceCompany',
  'parkingCompany',
  'houseExpert',
  'serviceManager',
  'keyManagementCompany',
] as const;

const isValidParameters = (
  obj: unknown
): obj is { serviceParty: (typeof servicePartyKeys)[number] } =>
  !!obj &&
  typeof obj === 'object' &&
  'serviceParty' in obj &&
  servicePartyKeys.some((key) => key === obj.serviceParty);
